class ValuesTabs extends HTMLElement {
  connectedCallback() {
    this._tablist = this.querySelector('[data-values-tablist]');
    this._panels = Array.from(this.querySelectorAll('[data-values-tab-panel]'));

    if (!this._tablist || this._panels.length === 0) {
      this._buttons = [];
      return;
    }

    this._tablist.replaceChildren();

    this._buttons = this._panels.map((panel, index) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'values-tabs__tab' + (index === 0 ? ' is-active' : '');
      btn.setAttribute('data-values-tab-button', '');
      btn.setAttribute('data-tab-index', String(index));

      let label = (panel.dataset.tabLabel || '').trim();
      if (!label) label = `Tab ${index + 1}`;
      btn.textContent = label;

      btn.addEventListener('click', () => this.select(index));
      this._tablist.appendChild(btn);

      panel.hidden = index !== 0;
      return btn;
    });
  }

  select(index) {
    if (!this._buttons?.length || !this._panels?.length) return;
    if (index < 0 || index >= this._panels.length) return;

    this._buttons.forEach((btn, i) => {
      btn.classList.toggle('is-active', i === index);
    });
    this._panels.forEach((panel, i) => {
      panel.hidden = i !== index;
    });
  }
}

customElements.define('values-tabs', ValuesTabs);
